// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stats-row[data-v-3bcda462]{display:flex;justify-content:center;gap:36px}.stats-item[data-v-3bcda462]{flex:1 1}.stats-item .text-4xl[data-v-3bcda462]{white-space:nowrap}@media(max-width: 767.98px){.stats-row[data-v-3bcda462]{flex-direction:column}.stats-item[data-v-3bcda462]{text-align:center}}.font-weight-semibold[data-v-3bcda462]{opacity:.8}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
